
export * from './lib/favorites.module';
export { FavoritesComponent } from './lib/favorites.component';
